import { render, staticRenderFns } from "./formItemGroup.vue?vue&type=template&id=5b2278b9&"
import script from "./formItemGroup.vue?vue&type=script&lang=js&"
export * from "./formItemGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports